module.exports = {
  name: 'Longhorn UI',
  prefix: 'antdAdmin',
  logoSrc: 'favicon.ico',
  version: 'v1.7.1', // eslint-disable-line no-template-curly-in-string
}
